import axiosConfig from "axios";
import { config } from "./config";

export const axios = axiosConfig.create({
  baseURL: config.API_BASE_URL,
  withCredentials: true,
});

// Add request interceptor to include platform header
axios.interceptors.request.use(
  (config) => {
    // Add platform header to every request
    config.headers['x-platform'] = "web";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
